export default "/kiban/_next/static/images/tel-768cf545d09cb9e54b931327c229a861.png";